"use strict";
// Copyright © 2021 Move Closer
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var HRModuleForm_1;
Object.defineProperty(exports, "__esModule", { value: true });
exports.HRModuleForm = void 0;
const vue_property_decorator_1 = require("vue-property-decorator");
const form_1 = require("../_abstract/form");
const _contracts_1 = require("../_contracts");
/**
 * @author Łukasz Jakubowski <lukasz.jakubowski@movecloser.pl>
 */
let HRModuleForm = HRModuleForm_1 = class HRModuleForm extends form_1.AbstractModuleForm {
    constructor() {
        super(...arguments);
        /**
         * @inheritDoc
         * @override
         */
        this.initialContent = HRModuleForm_1.getInitialContent();
    }
    /**
     * @inheritDoc
     * @override
     */
    static getInitialConfig() {
        return {
            driver: _contracts_1.ModuleDriver.HR,
            size: {
                colSpan: 6,
                rowSpan: 1,
                isResizable: false
            }
        };
    }
    /**
     * @inheritDoc
     * @override
     */
    static getInitialContent() {
        return {
            text: ''
        };
    }
};
HRModuleForm = HRModuleForm_1 = __decorate([
    vue_property_decorator_1.Component({
        name: 'HRModuleForm',
        template: `
    <div>
      {{ $t('forms.hr.placeholder') }}
    </div>
  `
    })
], HRModuleForm);
exports.HRModuleForm = HRModuleForm;
//# sourceMappingURL=HR.form.js.map